import React, { Component, createContext } from "react"
import PropTypes from "prop-types"
import { fetchTable } from "../api/apiCalls"
import PersonIcon from "@material-ui/icons/Person"
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount"
import BookIcon from "@material-ui/icons/Book"

let SchemaContext
const { Provider, Consumer } = (SchemaContext = createContext())

class SchemaProvider extends Component {
  constructor(props) {
    super(props)
    this.state = {
      schema: [],
      schemaTableDirty: false,
      schemaLoading: false,
      schemaError: null,
      schemaTable: [],
      schemaTableLoading: false,
      schemaTableError: null,
      fetchSchema: this.fetchSchema,
      fetchSchemaTable: this.fetchSchemaTable,
      setSchemaTableDirty: this.setSchemaTableDirty,
      setSchemaTableData: this.setSchemaTableData,
    }
  }

  fetchSchema = (user) => {
    this.setState({ schemaLoading: true })
    fetchTable(user, "schema")
      .then(async (response) => {
        if (response.ok) {
          let responseJSON = await response.json()
          console.log(" SCHEMA ", responseJSON)
          this.setState({
            schema: responseJSON,
            schemaLoading: false,
          })
        } else {
          throw new Error("Unable to connect to schema.")
        }
      })
      .catch((error) => {
        this.setState({
          schemaError: error.message,
          schemaLoading: false,
        })
      })
  }

  setSchemaTableDirty = () => {
    this.setState({ schemaTableDirty: true })
  }

  setSchemaTableData = (data) => {
    this.setState({ schemaTable: { ...this.state.schemaTable, data } })
  }

  fetchSchemaTable = (user) => {
    this.setState({ schemaTableLoading: true })
    fetchTable(user, "schematable")
      .then(async (response) => {
        if (response.ok) {
          let responseJSON = await response.json()
          console.log("responseJSON", responseJSON)
          let { columns } = responseJSON
          const columnsWithIcons = columns.map((item) => {
            if (item.title && item.title.toLowerCase().includes("permission")) {
              item.render = (rowData) => {
                const key = item.title.toLowerCase().includes("read")
                  ? rowData.view_permission_type_id
                  : rowData.edit_permission_type_id
                const color = item.title.toLowerCase().includes("read")
                  ? "secondary"
                  : "primary"
                let renderIcons
                switch (key) {
                  case 1:
                    renderIcons = (
                      <>
                        <BookIcon color={color} />
                        <PersonIcon color={color} />
                        <SupervisorAccountIcon color={color} />
                      </>
                    )
                    break
                  case 2:
                    renderIcons = (
                      <>
                        <PersonIcon color={color} />
                        <SupervisorAccountIcon color={color} />
                      </>
                    )
                    break
                  case 3:
                    renderIcons = (
                      <>
                        <SupervisorAccountIcon color={color} />
                      </>
                    )
                    break
                  default:
                    renderIcons = <></>
                }

                return renderIcons
              }
              return null
            } else {
              return item
            }
          })
          responseJSON = { ...responseJSON, columnsWithIcons }
          this.setState({
            schemaTable: responseJSON,
            schemaTableLoading: false,
            schemaTableDirty: false,
          })
        } else {
          throw new Error("Unable to connect to schema.")
        }
      })
      .catch((error) => {
        this.setState({
          schemaTableError: error.message,
          schemaTableLoading: false,
        })
      })
  }

  render() {
    return <Provider value={this.state}>{this.props.children}</Provider>
  }
}

SchemaProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export { SchemaProvider, Consumer as SchemaConsumer, SchemaContext }
